import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import Footer from '../../commons/Footer';
import { ReactComponent as IconRegistries } from '../../images/icn_anagrafiche.svg';
import SearchAddCont from '../../commons/SearchAddCont';
import './Profiles.scss';
import {
  ContFilterYear,
  ContPaginationPage,
  VerticalSpacing20,
} from '../../styled-components';
import { Row, Col, Label, FormGroup, CustomInput, Form } from 'reactstrap';
import Table from './Table';
import { ProfileStatus } from '../../lib/constants';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import variables from '../../variables';
import { refactoringAdminLevels } from '../../lib/helpers/refactoringAdminLevels';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';

function ProfilesPresentational(props) {
  const [t] = useTranslation('CONTACTS');

  const {
    data,
    total = 0,
    query = {},
    onFilter,
    isLoading = false,
    profileTypesCount = {},
    managers = [],
    softwares = [],
    pathname = '',
  } = props;

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          {pathname === 'historic' ? (
            <Header
              title={t('PAGES:HISTORIC_PROFILES')}
              icon={<IconRegistries fill={variables.white} />}
            />
          ) : (
            <Header
              title={t('PAGES:REGISTRIES')}
              icon={<IconRegistries fill={variables.white} />}
            />
          )}
        </section>
        <section>
          <Row>
            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:TITLE_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query.type || ''}
                        onChange={(e) => onFilter({ type: e.target.value })}
                      >
                        <option value="">Tutti</option>
                        {profileTypesCount.map((elem) => (
                          <option value={elem.type} key={elem.type}>
                            {t(refactoringAdminLevels(elem.type)) +
                              ' - ' +
                              elem.count}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:BRACELET_STATUS_FILTER')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectBraceletStatus"
                        name="braceletStatus"
                        value={query.braceletStatus || ''}
                        onChange={(e) =>
                          onFilter({ braceletStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="true">SI</option>
                        <option value="false">NO</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:CRM_STATUS_FILTER')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectCrmStatus"
                        name="crmStatus"
                        value={query.crmStatus || ''}
                        onChange={(e) =>
                          onFilter({ crmStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="true">SI</option>
                        <option value="false">NO</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:SOFTWARE_STATUS_FILTER')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectSoftwareStatus"
                        name="softwareStatus"
                        value={query.softwareStatus || ''}
                        onChange={(e) =>
                          onFilter({ softwareStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        {softwares.map((elem) => (
                          <option value={elem._id} key={elem._id}>
                            {elem.name}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>
                      {t('CONTACTS:ACTIVE_AFFILIATION_FILTER_TYPE')}
                    </Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectAffiliationStatus"
                        name="affiliationStatus"
                        value={query.affiliationStatus || ''}
                        onChange={(e) =>
                          onFilter({ affiliationStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="ACTIVATED">Attiva</option>
                        <option value="NOT_ACTIVATED">Non attiva</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:CANCELLATION_DATE_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="cancellationDateYear"
                        name="cancellationDateYear"
                        className="year-select"
                        value={
                          query && query.cancellationDateYear === null
                            ? ''
                            : query.cancellationDateYear
                        }
                        onChange={({
                          target: { value: cancellationDateYear },
                        }) => onFilter({ cancellationDateYear })}
                      >
                        {generateYearOptions(true)}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:CANCELLATION_DATE_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="cancellationDateMonth"
                        name="cancellationDateMonth"
                        className="year-select"
                        disabled={!query.cancellationDateYear}
                        value={
                          query && query.cancellationDateMonth === null
                            ? ''
                            : query.cancellationDateMonth
                        }
                        onChange={({
                          target: { value: cancellationDateMonth },
                        }) => onFilter({ cancellationDateMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:ACTIVE_USER_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectProfileStatus"
                        name="profileStatus"
                        value={query.profileStatus || ''}
                        onChange={(e) =>
                          onFilter({ profileStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        {ProfileStatus.map((type) => (
                          <option value={type} key={type}>
                            {t(type)}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="12" lg="12">
              <SearchAddCont
                isLoading={isLoading}
                onAdd={() => props.history.push('/profiles/create')}
                addLabel={t('COMMON:ADD')}
                onFilter={onFilter}
                query={query}
                pathname={pathname}
              />
            </Col>
          </Row>

          <VerticalSpacing20>
            <Table
              data={data}
              total={total}
              query={query}
              onFilter={onFilter}
              isLoading={isLoading}
              managers={managers}
              pathname={pathname}
            />
          </VerticalSpacing20>

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default withRouter(ProfilesPresentational);
